import type {
  CalendarDayPriceResult,
  DayPackagePriceResult,
  GetPaymentStatusQueryResult,
  ICreatePaymentIntentCommandResult,
} from "@repo/rq-api-public";
import { atom } from "jotai";
import { PaymentOption, type CustomerDetails } from "./types";

export const listingGuidAtom = atom<string | null>(null);
// Seeded once the listing loads: 1 when the account requires a passenger count,
// otherwise left null (leave-blank mode) until the customer enters a value.
export const passengersAtom = atom<number | null>(null);
export const customerDetailsAtom = atom<CustomerDetails | null>(null);

export const currentCalendarMonthDateAtom = atom<Date>(new Date());
export const selectedDateAtom = atom<Date>(new Date());

export const selectedPackageAtom = atom<DayPackagePriceResult | null>(null);
export const selectedSeasonAtom = atom<CalendarDayPriceResult | null>(null);

export const orderDataAtom = atom<
  | ({
      bookingGuid?: string;
      paymentGuid?: string;
      sessionGuid?: string;
      merchantId?: string;
      amount?: number;
      currency?: string;
      checkoutSessionUrl?: string;
    } & ICreatePaymentIntentCommandResult)
  | null
>(null);

export const promoCodeAtom = atom<{
  submittedCode: string | null;
  isLoading?: boolean;
  error?: string;
} | null>(null);

// Customer opt-ins, independently gated by the platform account settings.
export const cateringEmailOptInAtom = atom<boolean>(false);
export const boatingClubEmailOptInAtom = atom<boolean>(false);

export const orderStatusAtom = atom<
  | "PAYMENT_FAILED"
  | "SUCCESS"
  | "PENDING"
  | "SLOT_BOOKED"
  | "ENQUIRY_SENT"
  | null
>(null);

export const isPaymentSubmittingAtom = atom<boolean>(false);

export const isOrderCreatingAtom = atom<boolean>(false);

export const paymentResponseAtom = atom<GetPaymentStatusQueryResult | null>(
  null,
);

export const isGroupPricingPackagesAtom = atom<boolean>(false);
export const filterPricingGuidAtom = atom<string | null>(null);

export const campaignCodeAtom = atom<string | null>(null);

export const campaignValidationAtom = atom<{
  isValid: boolean | null; // null = not yet validated, true = valid, false = invalid
  isLoading: boolean;
  discountAmount?: number;
  error?: string;
}>({
  isValid: null,
  isLoading: false,
});

export const campaignApplicationResultAtom = atom<"success" | "failed" | null>(
  null,
);

export const currentStepAtom = atom<1 | 2 | 3>(1);

export const paymentOptionAtom = atom(PaymentOption.Full);

export const trackingParamsAtom = atom<{
  fbp: string | null;
  fbc: string | null;
  gaClientId: string | null;
  gclid: string | null;
  marketplaceSessionId: string | null;
}>({
  fbp: null,
  fbc: null,
  gaClientId: null,
  gclid: null,
  marketplaceSessionId: null,
});
